export default __webpack_public_path__ + "static/media/hht1_ep2_minisitcom_01.89462ba7.png";